<div class="tw:flex tw:flex-col tw:w-full tw:gap-4">
    @if (currentUser()?.permissions?.canCreateEditSales) {
        <div class="tw:flex tw:w-full tw:gap-4">
            <!-- When the sale is not cancelled and invoicing is not active, the user has permission to create or edit (add to) sales -->
            @if ((!isInvoicingActive() && sale.status !== ISaleStatus.CANCELLED) || sale.status === ISaleStatus.DRAFT) {
                <app-button type="secondary" class="tw:flex-1" extraClass="tw:w-full" (clickEvent)="editSale()">
                    {{ 'INVOICE_PREVIEW.editSale' | translate }}
                </app-button>
            }

            <!-- Create invoice for sale - only when invoicing is active, it uninvoiced or partially invoiced, and sale is not cancelled -->
            @if (
                isInvoicingActive() &&
                sale.status !== ISaleStatus.CANCELLED &&
                [InvoiceStatus.PARTIALLY_INVOICED, InvoiceStatus.UNINVOICED].includes(sale?.invoiceStatus)
            ) {
                <app-button type="primary" class="tw:flex-1" extraClass="tw:w-full" (clickEvent)="createFullInvoice()">
                    {{ 'INVOICE_PREVIEW.doInvoice' | translate }}
                </app-button>
            }

            <!-- Add payment - only when sale is pending payment -->
            @if (sale.status === ISaleStatus.PENDING_PAYMENT) {
                <!-- if has no invoicing or invoicing is active and sale is fully invoiced -->
                @if (!isInvoicingActive() || (isInvoicingActive() && sale.invoiceStatus === InvoiceStatus.INVOICED)) {
                    <app-button type="primary" class="tw:flex-1" extraClass="tw:w-full" (clickEvent)="addPayment()">
                        {{ 'INVOICE_PREVIEW.pay' | translate }}
                    </app-button>
                }
            }
        </div>
    }

    <!-- cancel / credit note  - all not cancelled sales-->
    @if (sale.status !== ISaleStatus.CANCELLED && currentUser()?.permissions?.canDeleteSales) {
        <app-button type="danger" class="tw:w-full" extraClass="tw:w-full" (clickEvent)="cancelInvoice()">
            @if (sale.status === ISaleStatus.DRAFT) {
                {{ 'SALES_LIST_PAGE.deleteDraft' | translate }}
            } @else if (isInvoicingActive()) {
                {{ 'INVOICE_PREVIEW.creditNote' | translate }}
            } @else {
                {{ 'GENERAL.cancel' | translate }}
            }
        </app-button>
    }
</div>
